import "mutationobserver-shim";
import Vue from "vue";
import VueMeta from 'vue-meta';
import router from "./router";
import store from "./store";
import App from "./App.vue";
import { LayoutPlugin, ToastPlugin } from "bootstrap-vue";
import VueFacebookPixel from "./utils/fb-pixel";
import "./app.scss";//  Import SCSS to override BootstrapVue default styling

Vue.use(VueMeta);

Vue.use(LayoutPlugin);
Vue.use(ToastPlugin);
Vue.use(VueFacebookPixel, { debug: false, router });  

/**
 * Init facebook tracking pixel
 * @param  {String} appId 
 * @param  {object} [data={}] 
 */
Vue.analytics.fbq.init("202041983476026", { em: "dave@almostalldigital.co.uk" });
Vue.config.productionTip = false;
Vue.prototype.$scrollToTop = () => window.scrollTo(0, 0);

export const eventBus = new Vue();
new Vue({ router, store, render: h => h(App) }).$mount("#app");
